import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-2-circle",
  "use": "icon-icon-2-circle-usage",
  "viewBox": "0 0 28 18.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 18.2\" id=\"icon-icon-2-circle\"><title>资源 1</title><g id=\"icon-icon-2-circle_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-2-circle_图层_1-2\" data-name=\"图层 1\"><path d=\"M18.9,0A8.4,8.4,0,0,0,14,1.5,8.4,8.4,0,0,0,9.1,0,9.1,9.1,0,1,0,14,16.8,9.1,9.1,0,1,0,18.9,0Zm0,16.2a6.9,6.9,0,0,1-3.2-.8,9.4,9.4,0,0,0,2.5-6.3,9.4,9.4,0,0,0-2.5-6.3A6.9,6.9,0,0,1,18.9,2a7.1,7.1,0,1,1,0,14.2Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-2-circle.svg
// module id = pRHw
// module chunks = 71